import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    // detectSessionInUrl on the Supabase client parses tokens from the URL.
    // We just wait for a session and redirect.
    const sub = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) navigate('/manage', { replace: true });
    });
    return () => sub.data.subscription.unsubscribe();
  }, [navigate]);

  return <p className="muted">Signing you in…</p>;
}
